package com.vamvisions.main.theme

import org.jetbrains.compose.web.css.CSSGroupingRuleDeclaration
import org.jetbrains.compose.web.css.CSSRuleDeclarationList
import org.jetbrains.compose.web.css.GenericStyleSheetBuilder

/** An `@supports` block; Compose HTML only ships `@media`. Built the same way as its `media`. */
fun <TBuilder> GenericStyleSheetBuilder<TBuilder>.supports(
    condition: String,
    rulesBuild: GenericStyleSheetBuilder<TBuilder>.() -> Unit,
) {
    add(CSSSupportsRuleDeclaration(condition, buildRules(rulesBuild)))
}

private data class CSSSupportsRuleDeclaration(
    val condition: String,
    override val rules: CSSRuleDeclarationList,
) : CSSGroupingRuleDeclaration {
    override val header: String
        get() = "@supports $condition"
}
